import React, { useMemo } from 'react';
import styled from 'styled-components';

import { calculateLeverage } from '#/api/apiUtils';
import Button from '#/components/basic/Button/Button';
import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import MarginTypeChip from '#/components/markets/intermittent/MarginTypeChip';
import {
  IAction,
  PanelState,
} from '#/components/trading/BuySellPanel/buyPanelReducer';
import { MarketData } from '#/reduxState/markets/listed/listedMarketsReducer';
import { useSelector } from '#/reduxState/store';

import LeverageModal from './LeverageModal';

const Centered = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .isMobileStyle & {
    /* Minimal size to prevent shifts on mobile */
    min-width: 50px;
    padding-left: 8px;
  }
`;

type Props = {
  dispatch: (action: IAction) => void;
  state: PanelState;
  marketData?: MarketData;
  marketInitialMarginFractionOverride: string | undefined | null;
};

export default function LeverageFieldsWithModal({
  dispatch,
  state,
  marketData,
  marketInitialMarginFractionOverride,
}: Props) {
  const isMobile = useSelector(state => state.screen.isMobile);
  const walletAddress = useSelector(state => state.wallet.walletAddress);

  const leverage = useMemo(
    () =>
      !marketData?.initialMarginFraction
        ? null
        : !walletAddress
        ? calculateLeverage(marketData.initialMarginFraction)
        : marketInitialMarginFractionOverride !== undefined
        ? calculateLeverage(
            marketInitialMarginFractionOverride ||
              marketData.initialMarginFraction
          )
        : null,
    [marketData, marketInitialMarginFractionOverride, walletAddress]
  );

  return (
    <>
      {state.state === 'leverageModal' &&
        marketData &&
        (!walletAddress ||
          marketInitialMarginFractionOverride !== undefined) && (
          <LeverageModal
            market={marketData.market}
            initialMarginFractionOverride={marketInitialMarginFractionOverride}
            onClose={() => dispatch({ type: 'closeLeverageModal' })}
          />
        )}

      <div>
        <Button
          onClick={() => dispatch({ type: 'openLeverageModal' })}
          color="black"
          fontNotBold
        >
          {isMobile ? (
            <Centered>
              {leverage && `${leverage}x`}{' '}
              {marketData?.marginType && (
                <MarginTypeChip
                  marginType={marketData.marginType}
                  marginLeft="4px"
                />
              )}
              <MaterialSymbol
                icon="arrow_drop_down"
                color="var(--gray4d)"
                rounded
              />
            </Centered>
          ) : leverage ? (
            <Centered>
              Leverage: {leverage}x{' '}
              {marketData?.marginType && (
                <MarginTypeChip
                  marginType={marketData.marginType}
                  marginLeft="4px"
                />
              )}
              <MaterialSymbol
                icon="arrow_drop_down"
                color="var(--gray4d)"
                rounded
              />
            </Centered>
          ) : null}
        </Button>
      </div>
    </>
  );
}
